import { useCallback, useEffect, useRef } from 'react';

import { getLastUploadActivityAt } from '@/lib/activeUploads';
import {
    TIMEOUT_INACTIVITY_MINUTES,
    USER_ACTIVITY_EVENTS,
} from '@/lib/constants';

export function useActivity(
    timeoutMinutes: number = TIMEOUT_INACTIVITY_MINUTES,
): [() => boolean] {
    const lastActivityRef = useRef(Date.now());

    const isUserActive = useCallback(() => {
        const now = Date.now();
        const idleTime = now - Math.max(
            lastActivityRef.current,
            getLastUploadActivityAt() ?? 0,
        );
        const timeoutThreshold = timeoutMinutes * 60 * 1000;
        return idleTime < timeoutThreshold;
    }, [timeoutMinutes]);

    const handleActivity = useCallback(() => {
        const newActivity = Date.now();
        lastActivityRef.current = newActivity;
    }, []);

    useEffect(() => {
        lastActivityRef.current = Date.now();

        USER_ACTIVITY_EVENTS.forEach((event) => {
            window.addEventListener(event, handleActivity, { passive: true });
        });
        return () => {
            USER_ACTIVITY_EVENTS.forEach((event) => {
                window.removeEventListener(event, handleActivity);
            });
        };
    }, [handleActivity]);

    return [isUserActive];
}
